import React, { useEffect } from 'react';

import { BulkEditIssueView } from '../bulk-work-create-common/BulkEditIssueView.tsx';
import { BulkConfigureView } from '../bulk-work-create-configure/BulkConfigureView.tsx';
import { useAiBulkFetchIssuesList } from '../../services/useAiBulkFetchIssuesList.tsx';
import { BulkCreateFlagsContainer } from '../bulk-work-create-common/BulkCreateFlagsContainer.tsx';
import { useBulkCreateLoggingEvents } from '../../utils/useBulkCreateLoggingEvents.tsx';
import { useGetIssueTypeFields } from '../../services/useGetIssueTypeFields.tsx';
import { useHandleCloseAndAddIssuesToPage } from '../../services/useCloseAndAddIssuesToPage.tsx';
import { useGetAllWorkflowValidators } from '../../services/useGetAllWorkflowValidators.tsx';

import { AiBulkDefaultView } from './AiBulkDefaultView.tsx';

export const AiBulkNavigationContainer = ({ onClose }: { onClose: () => void }) => {
	const { logAiInteractionInitiated } = useBulkCreateLoggingEvents();
	useGetIssueTypeFields();
	useGetAllWorkflowValidators();

	useEffect(() => {
		logAiInteractionInitiated();
	}, [logAiInteractionInitiated]);

	useAiBulkFetchIssuesList();
	useHandleCloseAndAddIssuesToPage(onClose);

	return (
		<>
			<AiBulkDefaultView onClose={onClose} />
			<BulkConfigureView />
			<BulkEditIssueView />
			<BulkCreateFlagsContainer />
		</>
	);
};
